import { render } from "./AddAboutMainSection.vue?vue&type=template&id=5a3e67da&scoped=true"
import script from "./AddAboutMainSection.vue?vue&type=script&lang=js"
export * from "./AddAboutMainSection.vue?vue&type=script&lang=js"

import "./AddAboutMainSection.vue?vue&type=style&index=0&id=5a3e67da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3e67da"]])

export default __exports__